// **---------------------------------------------------**
// -------------------------------------------------------
// Polyfill START

if (!Element.prototype.matches)
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;
        if (!document.documentElement.contains(el)) return null;
        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

// Polyfill END
// -------------------------------------------------------
// **---------------------------------------------------**

// **---------------------------------------------------**
// -------------------------------------------------------
// Functions START

if (typeof joss == 'undefined') {
    function joss(message) {
        console.log(message);
    }
}

function reenableButtons($form) {
    $form = $form || document;
    var $buttons = $form.querySelectorAll('input[type=submit], button[type=submit]');
    $buttons.forEach(function($button) {
        $button.classList.remove('disabled');
        $button.disabled = false;
        var text = '';
        if ($button.getAttribute('data-text')) {
            text = $button.textContent;
            $button.textContent = $button.getAttribute('data-text');
            $button.setAttribute('data-text', text);
        } else if ($button.getAttribute('data-html')) {
            text = $button.innerHTML;
            $button.innerHTML = $button.getAttribute('data-html');
            $button.setAttribute('data-html', text);
        }
    });
}

function resetFormErrors($form) {
    var elements = false;
    elements = $form.querySelectorAll('.Alert.has-error');
    if (elements) {
        elements.forEach(function ($ele) {
            $ele.innerHTML = '';
        });
    }
    elements = $form.querySelectorAll('.Alert');
    if (elements) {
        elements.forEach(function ($ele) {
            $ele.style.display = 'none';
        });
    }
    elements = $form.querySelectorAll('.js-error');
    if (elements) {
        elements.forEach(function ($ele) {
            $ele.parentNode.removeChild($ele);
        });
    }
    elements = $form.querySelectorAll('.FormElement.has-error');
    if (elements) {
        elements.forEach(function ($ele) {
            $ele.classList.remove('has-error');
        });
    }
}

function displaySuccess($form) {
    if (typeof $form == 'string') { $form = document.querySelector($form); }
    resetFormErrors($form);
    var $alert = $form.nextSibling;
    if (!$alert || !$alert.classList || !$alert.classList.contains('Alert') || !$alert.classList.contains('has-success')) {
        $alert = $form.parentNode.querySelector('.Alert.has-success');
    }
    if ($alert) {
        $form.style.display = 'none';
        $alert.style.display = 'block';
    }
    if (typeof Scrollbar !== 'undefined') {
        Scrollbar.getAll()[0].scrollIntoView($alert, {offsetTop: 100});
    }
}

function displayErrors($form, messages, skipReset) {
    if (typeof $form == 'string') { $form = document.querySelector($form); }
    $form = $form || document;
    skipReset = skipReset || false;
    if (!skipReset) {
        resetFormErrors($form);
    }
    var focusIt = true;
    for (var name in messages) {
        if (name == 'global') {
            var $alert = $form.querySelector('.Alert.has-error');
            if ($alert) {
                $alert.style.display = 'block';
                $alert.innerHTML += messages[name];
            }
            if (typeof Scrollbar !== 'undefined') {
                Scrollbar.getAll()[0].scrollIntoView($form, {offsetTop: 100});
            }
        } else {
            var $ele = $form.querySelector('*[name=' + name + ']');
            if ($ele) {
                if (focusIt && ($ele.offsetParent !== null)) {
                    $ele.focus();
                    focusIt = false;
                }
                var $formElement = $ele.closest('.FormElement');
                if ($formElement) {
                    $formElement.classList.add('has-error');
                    var $errorMessage = document.createElement('div');
                    $errorMessage.innerHTML = '<label for="'+ $ele.getAttribute('id') + '" class="js-error">' + messages[name] + '</label>';
                    $formElement.parentNode.insertBefore($errorMessage.firstChild, $formElement.nextSibling);
                }
            }
        }
    }
}

function sendFormAjax($form, callback, callbackArgs) {
    var data = new FormData($form);
    var req = new XMLHttpRequest();

    var action = $form.getAttribute('action');
    if (action.indexOf('?') < 0) {
        action += '?';
    }
    action += '&ajax';

    req.open('POST', action, true);
    req.responseType = 'json';
    req.onreadystatechange = function() {
        var response = req.response;
        if (response && typeof response == 'string') {
            try {
                response = JSON.parse(response);
            } catch (e) {}
        }
        if(req.readyState == 4 && req.status == 200) {
            if (callback) {
                if (window[callback]) {
                    callback = window[callback];
                }
                var args = [response];
                args = args.concat(callbackArgs);
                callback.apply(null, args);
            } else {
                if (response.result) {
                    if (response.replaceHtml) {
                        $form.innerHTML = response.replaceHtml;
                    }
                }
            }
        }
    }
    req.send(data);
}

function initFormButtons() {
    var $forms = document.querySelectorAll('form');
    $forms.forEach(function($form) {
        $form.addEventListener('submit', function (e) {
            var $buttons = this.querySelectorAll('input[type=submit], button[type=submit]');
            $buttons.forEach(function($button) {
                $button.classList.add('disabled');
                $button.disabled = true;
                var text = '';
                if ($button.getAttribute('data-text')) {
                    text = $button.textContent;
                    $button.textContent = $button.getAttribute('data-text');
                    $button.setAttribute('data-text', text);
                } else if ($button.getAttribute('data-html')) {
                    text = $button.innerHTML;
                    $button.innerHTML = $button.getAttribute('data-html');
                    $button.setAttribute('data-html', text);
                }
            });
        });
    });
}

function initJsValidate() {
    var $forms = document.querySelectorAll('form.js-validate');
    $forms.forEach(function($form) {
        $form.addEventListener('submit', function (e) {
            var errors = { };

            this.querySelectorAll('input, select, textarea').forEach(function($ele) {
                if ($ele.required && !$ele.value) {
                    errors[$ele.name] = $ele.getAttribute('data-required-text');
                }
            });

            this.querySelectorAll('.must-check-one').forEach(function($ele) {
                var checked = false;
                $ele.querySelectorAll('input[type=checkbox], input[type=radio]').forEach(function($chk) {
                    if ($chk.checked) {
                        checked = true;
                    }
                });
                if (!checked) {
                    if ('global' in errors) {
                        errors['global'] += '<br/>' + $ele.getAttribute('data-required-text');
                    } else {
                        errors['global'] = $ele.getAttribute('data-required-text');
                    }
                }
            });

            if (Object.keys(errors).length) {
                displayErrors(this, errors);
                reenableButtons(this);
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
        });
    });
}

function initJsForms() {
    var $forms = document.querySelectorAll('form.js-form');
    var DEBUG_FORM = false;
    if (DEBUG_FORM) {
        joss('---------------------');
        joss('initiating js forms');
        joss('---------------------');
    }
    var i = 1;
    $forms.forEach(function($form) {
        // joss(i++);
        $form.addEventListener('submit', function (e) {
            joss('---------------------');
            joss('submitting js forms');
            joss('---------------------');
            e.preventDefault();
            sendFormAjax(this, function (response) {
                joss('---------------------');
                joss('js forms response came back');
                joss('---------------------');
                if (response) {
                    //if (typeof response.toast != 'undefined') {
                    //    toast_them(response.toast);
                    //}
                    if (!response.error) {
                        if (response.url) {
                            location.href = response.url;
                        } else if (response.message == 'reload') {
                            location.href = location.href;
                        } else {
                            displaySuccess($form);
                        }
                    } else {
                        reenableButtons($form);
                        resetFormErrors($form);
                        if (response.message) {
                            displayErrors($form, { 'global': response.message }, true);
                        }
                        if (response.messages) {
                            displayErrors($form, response.messages, true);
                        }
                    }
                }
            });
        });
    });
}

function initFileInputs() {
    var fileInputs = document.querySelectorAll('input[type="file"]');
    if(fileInputs.length) {
        fileInputs.forEach(
            function (fileInput) {
                fileInput.addEventListener('change',function(e){
                    var filenames = [];
                    var target = e.target;
                    for (var i = 0; i < target.files.length; i++)
                        filenames.push(target.files[i].name);

                    var parent = target.parentNode;
                    var label = parent.querySelector('label');
                    label.innerText= filenames.join(',');
                });

            }
        );
    }
}

// Call this function on document ready
function initEverything() {
    initPartial();
}
// Call this function on ajax reload
function initPartial() {
    initFileInputs();
    initJsValidate();
    initJsForms();
}

// Functions END
// -------------------------------------------------------
// **---------------------------------------------------**

// **---------------------------------------------------**
// -------------------------------------------------------
// DOMContentLoaded START

document.addEventListener("DOMContentLoaded", function(e) {
    initEverything();
});

// DOMContentLoaded END
// -------------------------------------------------------
// **---------------------------------------------------**